import React, { useMemo } from 'react'

import classnames from 'classnames'

import useIsAdvancedPartnership from '../../../../../../../features/hooks/useIsAdvancedPartnership'

import { formatCurrency, formatNumber } from '../../../../../../../helpers/numbers'

import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  RIGHT_TYPE_POSTS
} from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/fields'

import useStyles from '../../../../styles'

const DeliveredCol = ({ right, currencySymbol }) => {
  const classes = useStyles()

  const isAdvancedPartnership = useIsAdvancedPartnership()

  const calcDelivered = useMemo(() => {
    if (right.allocation_type === DIGITAL_ALLOCATION_TYPE_BUDGET) {
      return right.delivered && right.budget && formatNumber((right.delivered / right.budget) * 100, { max: 2 })
    } else {
      return right.delivered && right.allocation && formatNumber((right.delivered / right.allocation) * 100, { max: 2 })
    }
  }, [right])

  const hideDeliveredPercent = isAdvancedPartnership && right['right_type'] === RIGHT_TYPE_POSTS

  return (
    <>
      <div>
        {right.allocation_type === DIGITAL_ALLOCATION_TYPE_BUDGET
          ? formatCurrency(right.delivered, { min: 2, max: 2 }, { symbol: currencySymbol })
          : formatNumber(right.delivered)}
      </div>
      {!hideDeliveredPercent && (
        <div className={classnames(classes.subText, classes.deliveredPercentage)}>
          {` (${calcDelivered || 0}% Delivered)`}
        </div>
      )}
    </>
  )
}

export default DeliveredCol
